import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { StorefrontBreadcrumbs } from '../../navigation/components/StorefrontBreadcrumbs';
import { SearchBar } from '../../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './ManageBuildDropdowns';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BaseHeader({
  dataTestId = 'base-header',
  backBreadcrumb,
  pathKey,
  title
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "end",
    "data-test-id": dataTestId,
    gap: "1000",
    justifyContent: "space-between",
    minBlockSize: "143px",
    paddingBlock: "600",
    position: "relative",
    children: [/*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      flexShrink: 0,
      gap: "200",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(StorefrontBreadcrumbs, {
        backBreadcrumb: backBreadcrumb,
        pathKey: pathKey,
        title: title
      }), /*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-600",
        children: title
      })]
    }), /*#__PURE__*/_jsx(View, {
      maxInlineSize: "600px",
      flexGrow: 1,
      alignSelf: "end",
      children: /*#__PURE__*/_jsx(SearchBar, {})
    })]
  });
}